import { getConceptCodes } from "@intocare/datatypes/lib/code-system";
import { composeValueSet } from "@intocare/datatypes/lib/value-set";

import { PART_OF_DAY } from "../../code-system/part-of-day";

export const PART_OF_DAY_DISPLAY = composeValueSet({
	name: "PART_OF_DAY_DISPLAY",
	description: "Current selection of parts of day for displaying observations.",
	system: PART_OF_DAY,
	include: getConceptCodes(PART_OF_DAY),
});
